import {
  RefundOfferCreationDetailsDto,
  RefundOfferCreationDetailsModel,
  RefundOfferIdDto,
  RefundOfferIdModel,
} from '../types/refund-offer'
import { transformCurrencyAmountDto } from './currency-amount'

export const transformRefundOfferCreationDetailsDto = (
  refundOfferCreationDetails: RefundOfferCreationDetailsDto,
): RefundOfferCreationDetailsModel => ({
  minAmount: transformCurrencyAmountDto(refundOfferCreationDetails.min_amount),
  maxAmount: transformCurrencyAmountDto(refundOfferCreationDetails.max_amount),
})

export const transformRefundOfferIdDto = ({
  refund_offer_id,
}: RefundOfferIdDto): RefundOfferIdModel => ({
  refundOfferId: refund_offer_id,
})
